// extracted by mini-css-extract-plugin
export default {"image":"oW-z","loaded":"pW-z"};